import React, { createContext, useContext, useState, useCallback } from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';

export type DrawerMode = 'copilot' | 'chat' | null;

interface FloatingDrawerState {
  isOpen: boolean;
  activeMode: DrawerMode;
  isPushMode: boolean;
  setOpen: (mode: DrawerMode) => void;
  close: () => void;
}

const FloatingDrawerContext = createContext<FloatingDrawerState>({
  isOpen: false,
  activeMode: null,
  isPushMode: false,
  setOpen: () => {},
  close: () => {},
});

export const FloatingDrawerProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [activeMode, setActiveMode] = useState<DrawerMode>(null)
  const isWide = useMediaQuery('(min-width: 1400px)')
  const isOpen = activeMode !== null
  const isPushMode = isOpen && isWide

  const setOpen = useCallback((mode: DrawerMode) => {
    setActiveMode(mode)
  }, [])

  const close = useCallback(() => {
    setActiveMode(null)
  }, [])

  return (
    <FloatingDrawerContext.Provider value={{isOpen, activeMode, isPushMode, setOpen, close}}>
      {children}
    </FloatingDrawerContext.Provider>
  )
}

export function useFloatingDrawer(): FloatingDrawerState {
  return useContext(FloatingDrawerContext)
}
